var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { AlertifyService } from '../../../services/alertify.service';
import { HubApiService } from '../../../services/hub.api.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ImageService } from '../../../services/image.service';
import { HubComponent } from '../hub.component';
import { ModalService } from '../../../common/services/modal.service';
import { ConfirmModalActions, ConfirmModalData } from '../../../common/components/confirm.modal/confirm.modal.provider';
import { ConfirmModalComponent } from '../../../common/components/confirm.modal/confirm.modal.component';
import { isEmptyArray } from '../../../common/extensions';
import { ImageSelectorCommand, ImageSelectorComponent, } from '../../../common/components/image.selector/image.selector.component';
var AISettingsComponent = /** @class */ (function (_super) {
    __extends(AISettingsComponent, _super);
    function AISettingsComponent(hubApiService, formBuilder, activatedRoute, parent, imageService, alertify, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.hubApiService = hubApiService;
        _this.formBuilder = formBuilder;
        _this.activatedRoute = activatedRoute;
        _this.parent = parent;
        _this.imageService = imageService;
        _this.alertify = alertify;
        _this.modalService = modalService;
        _this.selectedFiles = [];
        _this.failedLinksArr = [];
        _this.clientUploadedFiles = [];
        _this.linkContent = [];
        _this.isIncludeLinks = false;
        _this.isExtracting = false;
        _this.isUploadLinkContentEnded = false;
        _this.uploadLimit = 100;
        _this.isLoading = true;
        _this.isLoadingClinetUploadedFiles = false;
        _this.panelOpenState = false;
        _this.logoImgData = '';
        _this.command = new ImageSelectorCommand();
        return _this;
    }
    AISettingsComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.form = this.formBuilder.group({
            link: [null, [Validators.required]],
            linkContent: [null, []],
            defaultQuestion1: [null, []],
            defaultQuestion2: [null, []],
            introTitle: [null, []],
            introImage: [null, []],
            introContent: [null, []],
            avatarName: [null, []],
            avatarProfile: [null, []],
            avatarThumbnail: [null, []],
            avatarIntro: [null, []],
            logo: [null, []],
            privacyPolicyLink: [null, []],
            prompt: [null, []],
        });
        this.getAISettings();
        this.getTravelBuddyClientUploadedFiles();
    };
    AISettingsComponent.prototype.getAISettings = function () {
        var _this = this;
        this.hubApiService.getAISettings(this.hubName).subscribe(function (data) {
            if (!data) {
                _this.alertify.error("Something went wrong");
                return;
            }
            if (data.travelBuddy.ui.introduction && isEmptyArray(data.travelBuddy.ui.questions)) {
                data.travelBuddy.ui.questions = ['', ''];
            }
            if (!data.travelBuddy.ui.avatar.intro) {
                data.travelBuddy.ui.avatar.intro = "I'm your personal AI-powered travel assistant. Simply ask me a question, and I will provide you with relevant travel information and suggestions for your next trip to " + data.travelBuddy.cityName + "!";
            }
            _this.aiSettings = data;
            _this.isLoading = false;
        });
    };
    AISettingsComponent.prototype.getTravelBuddyClientUploadedFiles = function () {
        var _this = this;
        this.isLoadingClinetUploadedFiles = true;
        this.hubApiService.getTravelBuddyClientUploadedFiles(this.hubName).subscribe(function (data) {
            _this.clientUploadedFiles = data;
            _this.isLoadingClinetUploadedFiles = false;
        });
    };
    AISettingsComponent.prototype.uploadTravelBuddyClientFiles = function (event) {
        var _this = this;
        if (this.clientUploadedFiles.length + this.selectedFiles.length > this.uploadLimit) {
            this.alertify.warning("You can only upload a maximum of " + this.uploadLimit + " files/links.");
            event.immediateComplete();
            return;
        }
        this.hubApiService
            .uploadTravelBuddyClientFiles(this.hubName, this.selectedFiles)
            .finally(event.immediateComplete)
            .subscribe(function (data) {
            _this.selectedFiles = [];
            _this.getTravelBuddyClientUploadedFiles();
        });
    };
    AISettingsComponent.prototype.fileRead = function ($event) {
        this.selectedFiles = Array.from($event);
    };
    AISettingsComponent.prototype.deleteFile = function (file) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .deleteTravelBuddyClientFile(_this.hubName, file.openAIFileId)
                    .finally(event.complete)
                    .subscribe(function (data) {
                    _this.getTravelBuddyClientUploadedFiles();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to delete this file permanently?',
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    AISettingsComponent.prototype.extractLink = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var link, data, _loop_1, this_1, _i, _a, l;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        link = this.form.get('link').value;
                        if (!link) return [3 /*break*/, 6];
                        this.isExtracting = true;
                        this.linkContent = [];
                        this.failedLinksArr = [];
                        return [4 /*yield*/, this.hubApiService.extractContentFromLink(this.hubName, link)];
                    case 1:
                        data = _b.sent();
                        if (!data.content) {
                            this.isExtracting = false;
                            event.immediateComplete();
                            this.alertify.warning('No content found');
                            return [2 /*return*/];
                        }
                        if (data.failedLinks.length > 0)
                            this.alertify.warning('Some links failed to extract content : ', data.failedLinks);
                        this.linkContent = [
                            {
                                oriLink: link,
                                content: data.content,
                                links: data.links,
                                checked: true,
                                status: 'initial',
                            },
                        ];
                        if (!(this.isIncludeLinks && data.links.length)) return [3 /*break*/, 5];
                        _loop_1 = function (l) {
                            var dataInSub;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this_1.hubApiService.extractContentFromLink(this_1.hubName, l)];
                                    case 1:
                                        dataInSub = _a.sent();
                                        if (dataInSub.failedLinks.length > 0)
                                            this_1.failedLinksArr = this_1.failedLinksArr.concat(dataInSub.failedLinks);
                                        if (this_1.linkContent.any(function (x) { return x.oriLink === dataInSub.oriLink; }) || !dataInSub.content)
                                            return [2 /*return*/, "continue"];
                                        this_1.linkContent = this_1.linkContent.concat([
                                            {
                                                oriLink: dataInSub.oriLink,
                                                content: dataInSub.content,
                                                links: dataInSub.links,
                                                checked: true,
                                                status: 'initial',
                                            },
                                        ]);
                                        console.log('this.linkContent', this_1.linkContent);
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _i = 0, _a = data.links;
                        _b.label = 2;
                    case 2:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        l = _a[_i];
                        return [5 /*yield**/, _loop_1(l)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        // if (this.failedLinksArr.length > 0) {
                        //   this.alertify.warning('Some links failed to extract content:\n' + this.failedLinksArr.join('\n'));
                        // }
                        this.isExtracting = false;
                        this.isUploadLinkContentEnded = false;
                        event.immediateComplete();
                        return [3 /*break*/, 7];
                    case 6:
                        event.immediateComplete();
                        _b.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    AISettingsComponent.prototype.uploadExtractedContent = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _i, _a, lc, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.clientUploadedFiles.length + this.linkContent.length > this.uploadLimit) {
                            this.alertify.warning("You can only upload a maximum of " + this.uploadLimit + " files/links.");
                            event.immediateComplete();
                            return [2 /*return*/];
                        }
                        _i = 0, _a = this.linkContent.filter(function (x) { return x.checked && x.content && !_this.linkExists(x.oriLink); });
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 6];
                        lc = _a[_i];
                        lc.status = 'uploading';
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.hubApiService.uploadLinkContent(this.hubName, lc.oriLink, lc.content)];
                    case 3:
                        _b.sent();
                        lc.status = 'uploaded';
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        console.error(error_1);
                        lc.status = 'error';
                        return [3 /*break*/, 5];
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        event.immediateComplete();
                        this.isUploadLinkContentEnded = true;
                        this.getTravelBuddyClientUploadedFiles();
                        return [2 /*return*/];
                }
            });
        });
    };
    AISettingsComponent.prototype.linkExists = function (link) {
        return this.clientUploadedFiles.any(function (x) { return x.link === link; });
    };
    AISettingsComponent.prototype.getIsChecked = function () {
        var _this = this;
        return this.linkContent.filter(function (x) { return !_this.linkExists(x.oriLink); }).any(function (x) { return x.checked; });
    };
    AISettingsComponent.prototype.toLocalTime = function (iso) {
        return new Date(iso).toLocaleString();
    };
    AISettingsComponent.prototype.saveUI = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.aiSettings.travelBuddy.ui.otherInfo && this.aiSettings.travelBuddy.ui.otherInfo.privacyPolicyLink) {
                            if (!this.aiSettings.travelBuddy.ui.otherInfo.privacyPolicyLink.startsWith('http')) {
                                this.aiSettings.travelBuddy.ui.otherInfo.privacyPolicyLink =
                                    'https://' + this.aiSettings.travelBuddy.ui.otherInfo.privacyPolicyLink;
                            }
                        }
                        if (!this.logoImgData) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(this.logoImgData, 300)];
                    case 1:
                        res = _a.sent();
                        if (res.success) {
                            this.aiSettings.travelBuddy.ui.logo = res.url;
                        }
                        else {
                            this.alertify.error('Upload logo image error, please try again.');
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        this.hubApiService
                            .setTravelBuddyUI(this.hubName, this.aiSettings.travelBuddy.ui)
                            .finally(event.complete)
                            .subscribe(function (data) {
                            _this.alertify.successfully('Saved');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AISettingsComponent.prototype.chooseColor = function ($event) { };
    Object.defineProperty(AISettingsComponent.prototype, "isImg", {
        get: function () {
            // return url.match(/\.(jpeg|jpg|gif|png|webp)/) != null;
            if (this.logoImgData) {
                return true;
            }
            return this.aiSettings.travelBuddy.ui.logo && this.aiSettings.travelBuddy.ui.logo.startsWith('http');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AISettingsComponent.prototype, "hasIntroduction", {
        get: function () {
            if (!this.aiSettings || !this.aiSettings.travelBuddy || !this.aiSettings.travelBuddy.ui.introduction) {
                return false;
            }
            // check if any of the properties of tis.introduction are not null or empty
            for (var key in this.aiSettings.travelBuddy.ui.introduction) {
                if (this.aiSettings.travelBuddy.ui.introduction[key]) {
                    return true;
                }
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    AISettingsComponent.prototype.logoTextKeyup = function ($event) {
        if ($event) {
            this.logoImgSelector.clearImage();
            this.logoImgData = '';
        }
    };
    AISettingsComponent.prototype.promptTextKeyup = function ($event) {
        if ($event) {
            this.logoImgSelector.clearImage();
            this.logoImgData = '';
        }
    };
    AISettingsComponent.prototype.setIndicator = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.aiSettings.travelBuddy.indicator.prompt = this.form.get('prompt').value;
                this.hubApiService
                    .setTravelBuddyIndicator(this.hubName, this.aiSettings.travelBuddy.indicator)
                    .finally(event.complete)
                    .subscribe(function (data) {
                    _this.alertify.successfully('Saved');
                });
                return [2 /*return*/];
            });
        });
    };
    AISettingsComponent.prototype.onImageChange = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!file) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(file, 300)];
                    case 1:
                        _a.logoImgData = _b.sent();
                        console.log(this.logoImgData);
                        this.aiSettings.travelBuddy.ui.logo = '';
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AISettingsComponent.prototype.getEmbedScript = function () {
        return "\n      <div id=\"imgoingcalendar-wrapper\" route=\"/" + this.hubName + "/places\" url-change=\"true\" version=\"V3\" travel-buddy=\"true\" travel-buddy-right=\"48px\" travel-buddy-bottom=\"32px\">\n        <app-root></app-root>\n        <script type=\"text/javascript\" src=\"https://imgoingcalendar.com/imgoingscript.js\"></script>\n      </div>\n    ";
    };
    AISettingsComponent.prototype.getOnlyTravelBuddyEmbedScript = function () {
        return "\n      <div id=\"imgoingcalendar-wrapper\" route=\"/" + this.hubName + "/ai/travel-buddy\" url-change=\"true\" version=\"V3\" travel-buddy-right=\"48px\" travel-buddy-bottom=\"32px\">\n        <app-root></app-root>\n        <script type=\"text/javascript\" src=\"https://imgoingcalendar.com/imgoingscript.js\"></script>\n      </div>\n    ";
    };
    AISettingsComponent.prototype.copyLink = function () {
        this.copyToClip(this.getEmbedScript());
    };
    AISettingsComponent.prototype.copyOnlyTravelBuddyLink = function () {
        this.copyToClip(this.getOnlyTravelBuddyEmbedScript());
    };
    AISettingsComponent.prototype.copyToClip = function (content) {
        var aux = document.createElement('input');
        aux.setAttribute('value', content);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand('copy');
        document.body.removeChild(aux);
        this.alertify.success('Link is copied to the clipboard');
    };
    return AISettingsComponent;
}(BaseComponent));
export { AISettingsComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/ai.settings/ai.settings.component.ts.pre-build-optimizer.js